<template>
  <div class="cardDetail">
    <div class="cardLists">
      <van-swipe
        :loop="false"
        @change="changeCard"
        :initial-swipe="cardIndex"
        :width="280"
      >
        <van-swipe-item v-for="(item, idx) in cardLists" v-bind:key="idx">
          <div class="cardItem">
            <div class="card-logo">
              <img width="32" height="32" src="../../assets/image/sumguo.png" />
            </div>
            <div class="card-name">Stored value card</div>
            <div class="card-botton">
              <div class="text">{{ item.prepaidCardCode }}</div>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <van-tabs v-model="cardIndex">
      <van-tab v-for="(item, idx) in cardLists" v-bind:key="idx"
        ><div class="card-info">
          <van-divider />
          <van-grid :column-num="2" :border="false" style="height: 55px">
            <van-grid-item style="border-right: 1px solid #ccc" text="余额">
              <div class="van-grid-item__text">余额</div>
              <div class="value">{{ item.surplusMoney }}</div>
            </van-grid-item>
            <van-grid-item text="适用门店">
              <div class="van-grid-item__text">适用门店</div>
              <div class="value" v-if="!item.isApplicableStore">不适用</div>
              <div class="value" v-else>适用</div>
            </van-grid-item>
          </van-grid>
          <van-divider />
        </div>
        <div class="record">
          <van-cell-group title="储值卡变动记录">
            <div
              class="van-coupon-list__list van-coupon-list__list--with-bottom"
              style="height: 573px"
            >
              <div
                class="van-coupon"
                v-for="(item, idx) in records"
                v-bind:key="idx"
                v-on:click="onChange(idx)"
              >
                <div class="van-coupon__content">
                  <div class="van-coupon__head">
                    <h2 class="van-coupon__amount">
                      {{ item.moneyChange }}<span>元</span>
                    </h2>
                    <p class="van-coupon__condition">{{ item.condition }}</p>
                  </div>
                  <div class="van-coupon__body">
                    <p class="van-coupon__name">{{ item.time }}</p>
                  </div>
                </div>
                <p
                  v-if="item.shopName != null && item.shopName != ''"
                  class="van-coupon__description"
                >
                  {{ item.shopName }}
                </p>
              </div>
            </div>
          </van-cell-group>
        </div>
      </van-tab>
    </van-tabs>
    <!-- 弹出说明框 -->
    <van-dialog class="home-dialog" v-model="showDialog" overlay>
      <van-cell-group title="储值卡变动详情">
        <van-cell title="类型" :value="recordDetail.changeType" />
        <van-cell title="日期" :value="recordDetail.time" />
        <van-cell title="金额" :value="recordDetail.moneyChange" />
        <van-cell
          title="实付金额"
          v-if="recordDetail.actualPayment"
          :value="recordDetail.actualPayment"
        />
        <van-cell
          title="赠送金额"
          v-if="recordDetail.giveMoney"
          :value="recordDetail.giveMoney"
        />
        <van-cell
          v-if="recordDetail.shopName"
          title="门店"
          :value="recordDetail.shopName"
        />
        <div  v-if="recordDetail.traderOrder">

          <van-cell-group :title="'订单号:' + recordDetail.traderOrder">
            <div class="good-list">
            <van-cell
              v-for="(item, idx) in recordDetail.lists"
              v-bind:key="idx"
              :title="item.tradeGoodName + '   *' + item.number"
              :value="'￥' + item.finalAmount"
            />
            </div>
          </van-cell-group>
        </div>
      </van-cell-group>
    </van-dialog>
  </div>
</template>

<script>
import "../../assets/css/cardDetail.less";
import { getCardInfo } from "@/api/card";
import { queryPost, queryGet } from "@/api/common";

export default {
  name: "CardRecord",
  data() {
    return {
      showPopup: false,
      cardLists: [],
      cardNo: "",
      cardIndex: 0,
      chosenCoupon: -1,
      coupons: [],
      disabledCoupons: [],
      showList: true,
      showDialog: false,
      recordDetail: "",
      records: "",
      finished: false,
    };
  },
  components: {},
  created() {
    this.loadComments();
    this.loadCard();
  },
  methods: {
    loadComments() {
      // debugger
      let s = sessionStorage.getItem("shopInfo");
      let c = sessionStorage.getItem("cardInfo");
      this.shopInfo = s ? JSON.parse(s) : "";
      this.cardInfo = c ? JSON.parse(c) : "";
    },
    loadCard() {
      let _this = this;
      _this.cardNo = _this.cardInfo.prepaidCardCode;
      let phone = _this.cardInfo.tel;
      let params = {
        phone: phone,
        shopCode: _this.shopInfo.shopCode,
      };
      let url = "/api/mbrinfo/getStoredValueCard";
      queryGet(url, params)
        .then((resp) => {
          let _data = resp.data;
          if (_data.code == "0000") {
            let _result = _data.data;
            _this.cardLists = _result.results.valueCardQueryVo.valueCardVosl;
            for (let i = 0; i < _this.cardLists.length; i++) {
              if (_this.cardLists[i].prepaidCardCode == _this.cardNo) {
                _this.cardIndex = i;
                sessionStorage.setItem(
                  "cardInfo",
                  JSON.stringify(this.cardLists[i])
                );
                this.getCardRecord(_this.cardNo);
                break;
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCardRecord(valueCard) {
      const url = "/api/valueCardController/findExpensesRecord";
      let data = {
        shopCode: this.shopInfo.shopCode,
        valueCard: valueCard,
      };
      this.finished = false;
      queryPost(url, data).then((resp) => {
        let _data = resp.data;
        this.finished = false;
        if (_data.code == "0000") {
          this.coupons = [];
          let data = _data.data.results;
          this.records = data;
          for (let i = 0; i < data.length; i++) {
            let temp = data[i];
            let number = temp.number;
            let condition = temp.changeType;
            let actualPayment = temp.actualPayment;
            let giveMoney = temp.giveMoney;
            if (number != null && number > 0) {
              condition = "购买" + number + "件商品";
            }
            if (actualPayment != null && giveMoney != null) {
              condition = "充值" + actualPayment + " 赠送" + giveMoney;
            }
            temp.condition = condition;
          }
        }
      });
    },
    getCardInfoByNo(cardNo) {
      getCardInfo(cardNo)
        .then((resp) => {
          let _data = resp.data;
          if (_data.code == "0000") {
            this.cardLists = _data.results.valueCardVosl;
          } else {
            this.$toast.fail(_data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    changeCard(index) {
      sessionStorage.setItem("cardInfo", JSON.stringify(this.cardLists[index]));
      this.getCardRecord(this.cardLists[index].prepaidCardCode);
      this.cardIndex = index;
    },
    onChange(index) {
      this.showList = false;
      this.chosenCoupon = index;
      this.recordDetail = this.records[index];
      if (
        this.recordDetail.traderOrder != null &&
        this.recordDetail.traderOrder != ""
      ) {
        var params = {
          name: this.recordDetail.traderOrder,
        };
        let url = "/api/order/findByName";
        queryGet(url, params)
          .then((resp) => {
            let _data = resp.data;
            if (_data.code == "0000") {
              this.recordDetail.lists = _data.data.results;
            } else {
              this.$toast.fail(_data.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
      this.showDialog = true;
    },
    onExchange() {
      // this.coupons.push(coupon);
    },
  },
};
</script>


